import * as React from "react";
import { SBChatShow, SBChatChannel } from "../stores/SBChatStore";

interface Profile {
  id: number;
  [key: string]: any;
}

interface SBSendMessageProps {
  profile: Profile;
  authenticity_token: string;
  current_user_id: number;
  callback?: () => void;
  button_class?: string;
}

const SBSendMessage: React.FC<SBSendMessageProps> = ({
  profile,
  authenticity_token,
  current_user_id,
  callback = () => { },
  button_class = "btn btn-primary btn-rounded w-100"
}) => {
  const [state, setState] = React.useState({
    loading: false,
    success: false,
    error: null as string | null
  });

  const handleSendMessage = async () => {
    setState({ loading: true, success: false, error: null });

    try {
      const response = await fetch(`/profiles/${profile.id}/create_chat.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": authenticity_token
        },
        credentials: "same-origin",
        body: JSON.stringify({})
      });


      if (response.ok) {
        const data = await response.json();
        setState({ loading: false, success: true, error: null });
        callback();
        // Open chat modal with returned channel URL
        SBChatShow.set(true);
        SBChatChannel.set(data.channel_url);
      } else {
        const errorData = await response.json();
        setState({
          loading: false,
          success: false,
          error: errorData.error || "Failed to create chat"
        });
      }
    } catch (error) {
      setState({
        loading: false,
        success: false,
        error: "Network error occurred"
      });
    }
  };

  return (
    <div className="sb-send-message">
      <button
        type="button"
        className={button_class}
        onClick={handleSendMessage}
        disabled={state.loading}
      >
        <i className={`fa ${state.loading ? 'fa-spinner fa-spin' : 'fa-comment'} me-2`} aria-hidden="true"></i>
        {state.loading ? "Creating Chat..." : "Send Message"}
      </button>

      {state.error && (
        <p style={{ color: "red" }}>{state.error}</p>
      )}
    </div>
  );
};

export default SBSendMessage;
